import { NgModule } from '@angular/core';
import { ReserveMainComponent } from './reserve-main.component';
import { ReserveMainPageRoutingModule } from './reserve-main-routing.module';
import { SharedModule } from 'app/shared.module';
import { LockerDatePageModule } from 'app/components/reserve/locker-date/locker-date.module';
import { LockerTypePageModule } from 'app/components/reserve/locker-type/locker-type.module';
import { LockerSizePageModule } from 'app/components/reserve/locker-size/locker-size.module';
import { LockerCheckoutPageModule } from 'app/components/reserve/locker-checkout/locker-checkout.module';
import { LockerVisorPageModule } from 'app/components/reserve/locker-visor/locker-visor.module';

@NgModule({
  imports: [
    SharedModule,
    LockerDatePageModule,
    LockerTypePageModule,
    LockerSizePageModule,
    LockerCheckoutPageModule,
    LockerVisorPageModule,
    ReserveMainPageRoutingModule,
  ],
  declarations: [ReserveMainComponent]
})
export class ReserveMainPageModule {}
